module.exports = __webpack_public_path__ + "img/track-shipment.5c58a4d0.svg";